export const NOTIFICATION_TITLES = {
  "Question answer": "Question answer",
  "New query": "New query",
  "New offer": "New offer",
  "Offer accepted": "Offer accepted",
  "Offer rejected": "Offer rejected",
  "New Document Added": "New Document Added"
};
